import React from 'react';
export const SliderComponent = ({ children, sliderClass = '', arrowsClass = '', showArrows = false, initFrom }) => {
    return (React.createElement("slider-component", { ...{ class: `d:block pos:r ${sliderClass}` }, ...initFrom !== undefined && { 'data-slider-init-from': initFrom } },
        React.createElement("div", { "data-slider": "", className: "scrbar:none ov:y:h ov:x:a" }, children),
        showArrows &&
            React.createElement(React.Fragment, null,
                React.createElement("button", { className: `${arrowsClass} btn:cleared ae--fade pos:a t:0 lh:0 h:100`, "data-slider-prev": "", "aria-hidden": true },
                    React.createElement("s-svg", { "data-icon": "#icon--arrow-slider-left" })),
                React.createElement("button", { className: `${arrowsClass} btn:cleared ae--fade pos:a t:0 lh:0 h:100`, "data-slider-next": "", "aria-hidden": true },
                    React.createElement("s-svg", { "data-icon": "#icon--arrow-slider-right" })))));
};
